export function LoginPage() {
  return (
    <div className="min-h-screen bg-surface-950 dark:bg-surface-950 flex items-center justify-center p-4"
      style={{ background: 'linear-gradient(135deg, #050510 0%, #0f0f1a 50%, #1a0a2e 100%)' }}>

      {/* Background glow orb */}
      <div
        className="pointer-events-none fixed inset-0 overflow-hidden"
        aria-hidden="true"
      >
        <div
          className="absolute top-1/3 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] rounded-full opacity-20"
          style={{ background: 'radial-gradient(circle, #7c3aed 0%, transparent 70%)' }}
        />
      </div>

      {/* Login card */}
      <div className="relative w-full max-w-md">
        <div
          className="rounded-2xl p-10 border"
          style={{
            background: 'rgba(30, 30, 46, 0.60)',
            backdropFilter: 'blur(24px)',
            WebkitBackdropFilter: 'blur(24px)',
            borderColor: 'rgba(255, 255, 255, 0.10)',
            boxShadow: '0 8px 32px 0 rgba(0, 0, 0, 0.30), 0 0 40px rgba(124, 58, 237, 0.15)',
          }}
        >
          {/* Logo / Title */}
          <div className="text-center mb-8">
            <h1
              className="text-4xl font-bold tracking-widest text-white mb-3"
              style={{ fontFamily: 'Orbitron, ui-monospace, monospace' }}
            >
              DOCTRINE
            </h1>
            <div
              className="h-px w-24 mx-auto mb-4"
              style={{ background: 'linear-gradient(90deg, transparent, #7c3aed, transparent)' }}
            />
            <p
              className="text-sm tracking-wide"
              style={{ color: '#b486ff', fontFamily: 'Russo One, sans-serif' }}
            >
              Document Orchestration Platform
            </p>
          </div>

          {/* Sign in button */}
          <button
            type="button"
            onClick={() => { window.location.href = '/api/auth/google' }}
            className="w-full flex items-center justify-center gap-3 py-3 px-5 rounded-xl font-medium text-white cursor-pointer transition-all duration-200"
            style={{
              background: 'linear-gradient(135deg, #6d28d9 0%, #7c3aed 100%)',
              boxShadow: '0 4px 14px rgba(124, 58, 237, 0.35)',
            }}
            onMouseEnter={e => {
              const el = e.currentTarget
              el.style.background = 'linear-gradient(135deg, #7c3aed 0%, #9455e0 100%)'
              el.style.boxShadow = '0 0 20px rgba(124, 58, 237, 0.50)'
            }}
            onMouseLeave={e => {
              const el = e.currentTarget
              el.style.background = 'linear-gradient(135deg, #6d28d9 0%, #7c3aed 100%)'
              el.style.boxShadow = '0 4px 14px rgba(124, 58, 237, 0.35)'
            }}
          >
            {/* Google icon */}
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden="true">
              <path d="M17.64 9.2c0-.637-.057-1.251-.164-1.84H9v3.481h4.844c-.209 1.125-.843 2.078-1.796 2.717v2.258h2.908c1.702-1.567 2.684-3.875 2.684-6.615z" fill="#ffffff" fillOpacity="0.9"/>
              <path d="M9 18c2.43 0 4.467-.806 5.956-2.18l-2.908-2.259c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H.957v2.332A8.997 8.997 0 0 0 9 18z" fill="#ffffff" fillOpacity="0.9"/>
              <path d="M3.964 10.71A5.41 5.41 0 0 1 3.682 9c0-.593.102-1.17.282-1.71V4.958H.957A8.996 8.996 0 0 0 0 9c0 1.452.348 2.827.957 4.042l3.007-2.332z" fill="#ffffff" fillOpacity="0.9"/>
              <path d="M9 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.463.891 11.426 0 9 0A8.997 8.997 0 0 0 .957 4.958L3.964 7.29C4.672 5.163 6.656 3.58 9 3.58z" fill="#ffffff" fillOpacity="0.9"/>
            </svg>
            Sign in with Google
          </button>

          <p className="mt-6 text-center text-xs" style={{ color: 'rgba(255,255,255,0.30)', fontFamily: 'Share Tech Mono, ui-monospace, monospace' }}>
            Access restricted to authorized operators
          </p>
        </div>
      </div>
    </div>
  )
}
